import enUSLocale from "date-fns/locale/en-US";
import enGBLocale from "date-fns/locale/en-GB";
import heLocale from "date-fns/locale/he";
import frLocale from "date-fns/locale/fr";
import esLocale from "date-fns/locale/es";
import ptLocale from "date-fns/locale/pt";
import deLocale from "date-fns/locale/de";
export const localeSettings: {
  [key: string]: {
    locale: string;
    country: string;
    countryCode: string;
    localeFormat: any;
    dateTemplate: string;
    timeTemplate: string;
  };
} = {
  en: {
    country: "us",
    countryCode: "1",
    locale: "en-US",
    localeFormat: enUSLocale,
    dateTemplate: "MM/dd/yyyy",
    timeTemplate: "hh:mm a",
  },
  en_GB: {
    country: "uk",
    countryCode: "44",
    locale: "en-GB",
    localeFormat: enGBLocale,
    dateTemplate: "dd/MM/yyyy",
    timeTemplate: "HH:mm",
  },
  he: {
    country: "il",
    countryCode: "972",
    locale: "he-IL",
    localeFormat: heLocale,
    dateTemplate: "dd/MM/yyyy",
    timeTemplate: "HH:mm",
  },
  fr: {
    country: "fr",
    countryCode: "33",
    locale: "fr-FR",
    localeFormat: frLocale,
    dateTemplate: "dd/MM/yyyy",
    timeTemplate: "HH:mm",
  },
  es: {
    country: "es",
    countryCode: "34",
    localeFormat: esLocale,
    locale: "es-ES",
    dateTemplate: "dd/MM/yyyy",
    timeTemplate: "HH:mm",
  },
  pt: {
    country: "pt",
    countryCode: "351",
    localeFormat: ptLocale,
    locale: "pt-PT",
    dateTemplate: "dd/MM/yyyy",
    timeTemplate: "HH:mm",
  },
  de: {
    country: "de",
    countryCode: "49",
    localeFormat: deLocale,
    locale: "de-DE",
    dateTemplate: "dd/MM/yyyy",
    timeTemplate: "HH:mm",
  },
};
